(function () {
    'use strict';

    angular
        .module('planDeliverableModule')
        .controller('grcPlanDeliverableFullController', Controller);

    Controller.$inject = ['$rootScope', '$scope', '$state', '$mdToast', 'businessPlanningService', 'initiativeUpdateStatusService', 'followUpService'];

    function Controller($rootScope, $scope, $state, $mdToast, businessPlanningService, initiativeUpdateStatusService, followUpService) {

        // Show Reset Action?
        $scope.showResetAction = function () {
            return $scope.ctxtDir.needSaveChanges;
        };

        // Show Save Action?
        $scope.showSaveAction = function (form) {
            if (form.$invalid) { return false; }

            return $scope.ctxtDir.needSaveChanges;
        };

        // Page is dirty
        $scope.ctxtDir                  = {};
        $scope.ctxtDir.needSaveChanges  = false;
        $scope.ctxtDir.showNavCollapsed = true;

        $scope.pageIsDirty = function () {
            $scope.ctxtDir.needSaveChanges = true;
            $rootScope.$broadcast('page-is-dirty');
        };

        $scope.pageIsNotDirty = function () {
            $scope.ctxtDir.needSaveChanges = false;
            $rootScope.$broadcast('page-is-not-dirty');
        };

        // Create Or Update
        $scope.createOrUpdate = function () {
            $scope.isLoading = true;
            var isCreation = !$scope.boxModel.PlanDeliverableID;
            
            if ($scope.boxModel.TargetDate) {
                $scope.boxModel.TargetDate = moment($scope.boxModel.TargetDate);
            }
            
            businessPlanningService
                .createOrUpdateDeliverable($scope.boxModel.PlanInitiativeID, $scope.boxModel)
                .then(function (updatedDeliverable) {
                    $scope.pageIsNotDirty();

                    var action = isCreation ? 'added' : 'updated';

                    $mdToast.show(
                        $mdToast
                            .simple()
                            .content('Plan Deliverable has been ' + action)
                            .position('top right')
                            .hideDelay($scope.govNotificationDelay)
                            .action('OK')
                            .theme('primary')
                    );

                    $state.go('initiative.edit.deliverable.edit', {
                        PlanDeliverableID: updatedDeliverable.PlanDeliverableID
                    }, {
                        reload: true
                    });
                })
                .finally(function() {
                    $scope.isLoading = false;
                });
        };

        // Delete Deliverable
        $scope.deleteDeliverable = function () {
            $scope.isLoading = true;

            return businessPlanningService
                     .deletePlanDeliverable($scope.boxModel.PlanInitiativeID, $scope.boxModel.PlanDeliverableID)
                     .then(function () {
                         $scope.pageIsNotDirty();

                         $mdToast.show(
                             $mdToast
                                 .simple()
                                 .content('Plan Deliverable has been deleted')
                                 .position('top right')
                                 .hideDelay($scope.govNotificationDelay)
                                 .action('OK')
                                 .theme('primary')
                         );

                         $state.go('initiative.edit.deliverable', {}, {
                             reload: true
                         });
                     })
                     .finally(function () {
                         $scope.isLoading = false;
                     });
        };
        $scope.showDeleteDeliverable = function () {
            return !_.isUndefined($scope.boxModel.PlanDeliverableID) && $scope.canEdit;
        };

        // Reset forms
        $scope.reset = function () {
            $scope.isLoading = true;
            $state.reload();
        };

        // Deliverable Tag
        // Get All
        $scope.allDeliverableTags = [];
        businessPlanningService.getPlanLookups()
            .then(function (containerPlanLookups) {
                $scope.allDeliverableTags = containerPlanLookups.DeliverableTags;
                $scope.filteredDeliverableTags = getFilteredDeliverableTags();
            });

        var getFilteredDeliverableTags = function () {
            var filtered = [];
            _.forEach($scope.allDeliverableTags, function (tag) {
                var index = _.findIndex($scope.boxModel.DeliverableTagList, function (selectedTag) {
                    return selectedTag.TitleEN === tag.TitleEN;
                });
                if (index < 0) {
                    filtered.push(tag);
                }
            });

            return filtered;
        }        

        // Selection Changed
        $scope.deliverableTagListChanged = function () {
            $scope.filteredDeliverableTags = getFilteredDeliverableTags();
            $scope.pageIsDirty();
        }

        // Show open followUps action?
        $scope.showOpenFollowUpsAction = function () {
            if (!$scope.boxModel.PlanDeliverableID) return false;

            return !$scope.ctxtDir.needSaveChanges;
        };

        // Open Followups
        $scope.openFollowups = function () {
            businessPlanningService
                .getFollowUpsByPlanDeliverableID($scope.boxModel.PlanInitiativeID,
                                                 $scope.boxModel.PlanDeliverableID)
                .then(function (delivAssContainers) {
                    followUpService.openFollowUpsModal($scope.boxModel.TitleEN,
                                                      null,
                                                      null,
                                                      delivAssContainers,
                                                      getDownloadAttachmentUrl);
                });
        };

        function getDownloadAttachmentUrl(attachmentId, delivAssessment) {

            return initiativeUpdateStatusService
                    .getDownloadAttachmentUrl($scope.authenticatedUser.ItemPersonID,
                                              $scope.boxModel.PlanInitiativeID,
                                              $scope.boxModel.PlanDeliverableID,
                                              delivAssessment.PlanDeliverableAssessmentID,
                                              attachmentId);
        }
    }

})();